import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Container, Avatar } from './styles'
import avatar from '../../Assets/Images/Artists/Placeholder/placeholder.png'
import Seen from '../Seen'

class Profile extends Component {

  markAsSeen = (username) => {
    let storage = typeof localStorage.getItem("seen") === 'string' ? JSON.parse(localStorage.getItem("seen")) : undefined
    if (Array.isArray(storage) && !storage.includes(username)) {
      localStorage.setItem('seen', JSON.stringify([username, ...storage]))
    } else if (Array.isArray(storage) && storage.includes(username)) {
      localStorage.setItem('seen', JSON.stringify([...storage]))
    } else {
      localStorage.setItem('seen', JSON.stringify([username]))
    }
  }

  isSeen = (username) => {
    let storage = localStorage.getItem("seen") ? JSON.parse(localStorage.getItem("seen")) : undefined
    if (storage) {
      return storage.includes(username)
    }
  }

  changeLocation = (url) => {
    window.location = url
  }

  render() {
    return(
      <Container solo={this.props.solo}>
        <Avatar solo={this.props.solo}>
          {
            (this.props.link)
            ? (
            <a
              href={this.props.url}
              target="_blank"
              rel="noopener noreferrer"
              className="img-anchor">
              <img src={this.props.avatar} alt="Someone with no face." />
              { (this.props.seen || this.isSeen(this.props.username)) &&
                  <Seen />
              }
            </a>
            )
            : (
            <Link
              to={`/feed/${this.props.username}`}
              onClick={() => this.markAsSeen(this.props.username)}
              className="img-anchor">
              <img src={this.props.avatar} alt="Someone with no face." />
              { (this.props.seen || this.isSeen(this.props.username)) &&
                  <Seen />
              }
            </Link>
            )
          }
        </Avatar>
        { !this.props.anonymous &&
          <p><a
            href={this.props.url}
            target="_blank"
            rel="noopener noreferrer">{ this.props.name }</a></p>
        }
      </Container>
    )
  }
}

Profile.defaultProps = {
  name: 'unsigned',
  username: 'unsgn',
  avatar: avatar,
  url: '#',
  seen: false,
  anonymous: true
}

export default Profile



// WEBPACK FOOTER //
// ./src/Components/Profile/index.js